import { useEffect, useState } from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Components
import Icon from '@/assets/icons'
import Connecting from '@/components/pages/LiveRoom/sharedComponents/Connecting'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface MicRequestProps {
  className?: string
  handleMicRequest?: () => void
  handleMicWaitingClick?: () => void
  isWaitingConnect: boolean
  isMicConnecting: boolean
}

const lottieVideoLength = 6000

const MicRequest = (props: MicRequestProps) => {
  const { className, handleMicRequest = () => {}, handleMicWaitingClick = () => {}, isWaitingConnect, isMicConnecting } = props

  const { t } = useTranslation()

  const [canShow, setCanShow] = useState(true)

  const isShowConnectButton = !isWaitingConnect && !isMicConnecting

  useEffect(() => {
    let timerId: any = 0

    if (isShowConnectButton) {
      timerId = setTimeout(() => {
        setCanShow(false)
      }, lottieVideoLength)
    }

    return () => {
      clearTimeout(timerId)
    }
  }, [])

  return (
    <>
      {isShowConnectButton && canShow && <Connecting />}

      <div className={cx('mic', className)}>
        {isShowConnectButton && (
          <>
            <div className={cx('mic-request')} onClick={handleMicRequest}>
              <p className={cx('mic-request-text')}>{t('LiveRoom_Mic_Request')}</p>
              <div className={cx('mic-request-icon')}>
                <Icon.Microphone />
              </div>
            </div>
            <div className={cx('mic-request__border-mask')}></div>
            <div className={cx('mic-request__border')}></div>
          </>
        )}

        {isWaitingConnect && !isMicConnecting && (
          <>
            <div className={cx('mic-wait')} onClick={handleMicWaitingClick}>
              <p className={cx('mic-wait-text')}>{t('LiveRoom_Mic_Connecting')}</p>
            </div>
            <div className={cx('mic-wait__border-mask')}></div>
            <div className={cx('mic-wait__border')}></div>
          </>
        )}
      </div>
    </>
  )
}

export default MicRequest
